import { ApiError } from "./api";

/** Turn a mutation error into a user-facing string suitable for inline auth forms. */
export function authErrorMessage(err: unknown): string | null {
  if (!err) return null;
  if (err instanceof ApiError) {
    if (err.status === 0) return "Can't reach the server. Check your connection.";
    if (err.status === 401) return "Invalid credentials.";
    if (err.status === 403) return err.message || "Your account isn't active.";
    if (err.status === 429) return "Too many attempts. Wait a minute and try again.";
    if (err.status === 400) return err.message || "Check the fields and try again.";
    return err.message || "Something went wrong.";
  }
  return (err as Error)?.message || "Something went wrong.";
}
